import React from "react";
import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";
import { REVIEWS } from "../../data/zingly";

export const Reviews = () => {
  return (
    <section
      id="reviews"
      data-testid="reviews-section"
      className="relative py-24 md:py-32 bg-white overflow-hidden"
    >
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[600px] rounded-full bg-[#F58220]/5 blur-3xl pointer-events-none" />
      <div className="max-w-7xl mx-auto px-5 md:px-10 relative">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <div className="inline-block text-xs uppercase tracking-[0.3em] text-[#F58220] font-semibold mb-3">
            Customer Love
          </div>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl font-extrabold text-[#1E1E1E] heading-accent">
            What Our Customers Say
          </h2>
          <p className="mt-6 text-base md:text-lg text-[#555555] max-w-2xl mx-auto">
            Fresh Taste • Happy Customers • Every Single Day
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-7">
          {REVIEWS.map((r, i) => (
            <motion.div
              key={r.name}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.7, delay: i * 0.15 }}
              whileHover={{ y: -8, rotateX: 3, rotateY: -3, scale: 1.02 }}
              style={{ transformStyle: "preserve-3d", perspective: "1000px" }}
              className="relative bg-[#FFF8F1] rounded-3xl p-8 border border-orange-100 shadow-[0_10px_30px_-12px_rgba(0,0,0,0.1)] hover:shadow-[0_25px_50px_-12px_rgba(245,130,32,0.25)] transition-shadow"
              data-testid={`review-card-${i}`}
            >
              <Quote className="absolute top-6 right-6 w-8 h-8 text-[#F58220]/20" />
              <div className="flex items-center gap-1 mb-5">
                {[...Array(r.rating)].map((_, j) => (
                  <Star key={j} className="w-5 h-5 fill-[#F58220] text-[#F58220]" />
                ))}
              </div>
              <p className="text-[#1E1E1E] leading-relaxed text-[15px]">&ldquo;{r.text}&rdquo;</p>
              <div className="mt-8 flex items-center gap-3">
                <div className="w-12 h-12 rounded-full bg-gradient-to-br from-[#F58220] to-[#E16608] flex items-center justify-center text-white font-bold">
                  {r.initials}
                </div>
                <div>
                  <div className="font-semibold text-[#1E1E1E]">{r.name}</div>
                  <div className="text-xs text-[#555555]">Verified Customer</div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
